<template>
  <div class="activity-cell">
    <div class="activity-time">{{ getTime }}</div>
    <img class="activity-pic" :src="value.cover || defaultImg">
    <div class="detail-info">
      <div class="activity-name">{{ value.name || "任务名称" }}</div>
      <!-- <div class="activity-tags" v-if="value.label.length > 0">
        <div class="tags-item" v-for="(tag, index) in value.label" :key="index">
          {{ tag.labelName || "" }}
        </div>
      </div> -->
      <!-- <div v-if="value.maxAccessMoney > 0" class="award-info">
        <img
          class="award-icon"
          src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/ba99a6ad-00a0-4e11-8700-46bc859ac0c7.png"
        />
        <div class="income">
          <span>预估收益 </span
          ><span style="color: #f0142d">{{ value.maxAccessMoney || 0 }}元</span>
        </div>
      </div> -->
      <!-- 其他活动红包和礼品 -->
      <!-- <div class="award-info" v-else-if="value.isRed || value.isGift">
        <div
          v-if="value.isRed"
          class="flex-row-nowrap"
          style="margin-right: 3vw"
        >
          <img
            class="award-icon"
            src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/ba99a6ad-00a0-4e11-8700-46bc859ac0c7.png"
          />
          <div class="income">转发得红包</div>
        </div>
        <div class="flex-row-nowrap" v-if="value.isGift">
          <img
            class="award-icon"
            src="https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/default/a708a9ae-a515-4e65-b37c-f68998ecf268.png"
          />
          <div class="income">免费领好礼</div>
        </div>
      </div> -->
      <!-- <div class="tip-but-cell">
        <div v-if="value.partner.businessName" class="partner-info">
          <div class="txt">{{ value.partner.businessName }}</div>
          <div style="margin: 0 8rpx">|</div>
          <div class="txt">{{ value.partner.empName }}</div>
        </div>
        <div class="detail-txt">
          <div>{{ value.userNumber || "0" }}人浏览</div>
        </div>
      </div> -->
    </div>
    <img
      v-if="selectId && value.id == selectId"
      class="select-icon"
      src="../../assets/selected.png"
    >
    <img v-else class="select-icon" src="../../assets/unselect.png">
  </div>
</template>
<script>
export default {
  name: "ActivityItem",
  props: {
    value: Object,
    selectId: String,
  },
  data() {
    return {
      defaultImg:
        "https://resource.tuixb.cn/beta/00000000-0000-0000-0000-000000000000/KMA/miniapp/cover-data-error.png",
    };
  },
  computed: {
    getTime() {
      let endDateStr = this.value.taskEndDate || this.value.activeEndDate;
      let startDateStr = this.value.taskStartDate || this.value.activeStartDate;
      let regPos = /^\d+(\.\d+)?$/; // 非负浮点数
      // 开始时间毫秒数
      let date_start_ms = 0;
      if (regPos.test(startDateStr)) {
        date_start_ms = parseInt(startDateStr);
      } else {
        startDateStr = startDateStr.replace(/-/g, "/");
        date_start_ms = new Date(startDateStr).getTime();
      }
      if (date_start_ms > new Date().getTime()) {
        return "未开始";
      }
      // 结束时间毫秒数
      let date_ms = 0;
      if (regPos.test(endDateStr)) {
        date_ms = parseInt(endDateStr);
      } else {
        endDateStr = endDateStr.replace(/-/g, "/");
        date_ms = new Date(endDateStr).getTime();
      }
      // 当前时间毫秒数
      let now_ms = new Date().getTime();
      // 判断是否结束
      if (date_ms <= now_ms) {
        return "已结束";
      }
      // 计算倒数计时秒数
      let time_m = Math.round((date_ms - now_ms) / 1000);
      let day = Math.floor(time_m / (60 * 60 * 24));
      let hours = Math.floor((time_m % (60 * 60 * 24)) / (60 * 60));
      let minutes = Math.floor((time_m % (60 * 60)) / 60);
      return `距结束：${day}天${hours}小时${minutes}分钟`;
    },
  },
};
</script>

<style scoped>
.flex-row-nowrap {
  display: flex;
  flex-flow: row nowrap;
}
.activity-cell {
  width: 7rem;
  height: 3.4rem;
  background: #ffffff;
  border-radius: 0.04rem;
  margin-top: 0.2rem;
  margin-left: 0.25rem;
  position: relative;
}
.activity-time {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.34rem;
  background: rgba(240, 20, 45, 0.06);
  border-radius: 0 0 0.08rem 0;
  font-size: 0.22rem;
  line-height: 0.34rem;
  padding: 0 0.12rem;
  color: rgba(240, 20, 45, 0.8);
}
.activity-pic {
  position: absolute;
  left: 0.29rem;
  top: 0.6rem;
  width: 1.64rem;
  height: 2.4rem;
  overflow: hidden;
  object-fit: cover;
  object-position: 50% 0;
  border: solid 1px #f7f8ff;
}
.detail-info {
  position: absolute;
  left: 2.4rem;
  top: 0.6rem;
  width: 4.66rem;
  height: 2.4rem;
  display: flex;
  flex-flow: column;
}
.activity-name {
  font-size: 0.28rem;
  line-height: 0.4rem;
  font-weight: bold;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.activity-tags {
  display: flex;
  flex-flow: row wrap;
  margin-top: 2vw;
}
.activity-tags .tags-item {
  background: #e5f9ef;
  line-height: 4.3vw;
  height: 4.3vw;
  border-radius: 1vw;
  padding: 0 1.74vw;
  font-size: 2.7vw;
  color: #07c160;
  margin-right: 2vw;
}
.award-info {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-top: 2.7vw;
  height: 4.3vw;
}
.award-info .award-icon {
  width: 3.5vw;
  height: 3.5vw;
  margin-right: 1vw;
}
.award-info .income {
  font-size: 3vw;
  color: #969799;
}
.tip-but-cell {
  flex-grow: 1;
  position: relative;
  height: 4vw;
  margin-top: 2.7vw;
}
.partner-info {
  display: flex;
  font-size: 2.7vw;
  line-height: 3.2vw;
  color: #969799;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  position: absolute;
  top: 0;
}

.partner-info .txt {
  max-width: 18.7vw;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.detail-txt {
  font-size: 2.7vw;
  line-height: 3.2vw;
  color: #969799;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.select-icon {
  width: 0.42rem;
  height: 0.42rem;
  position: absolute;
  right: 0.35rem;
  bottom: 0.3rem;
}
</style>